module.exports = __webpack_public_path__ + "img/archi@2x.528af40a.png";